export default (data: unknown) => data instanceof Date;
